import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLeftKeyboardHints = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 19,
	viewBox: "0 0 25 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M4.49463 1.28223H20.4946C22.4276 1.28223 23.9946 2.84923 23.9946 4.78223V14.7822C23.9946 16.7152 22.4276 18.2822 20.4946 18.2822H4.49463C2.56163 18.2822 0.994629 16.7152 0.994629 14.7822V4.78223C0.994629 2.84923 2.56163 1.28223 4.49463 1.28223Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.49463 1.28223H20.4946C22.4276 1.28223 23.9946 2.84923 23.9946 4.78223V14.7822C23.9946 16.7152 22.4276 18.2822 20.4946 18.2822H4.49463C2.56163 18.2822 0.994629 16.7152 0.994629 14.7822V4.78223C0.994629 2.84923 2.56163 1.28223 4.49463 1.28223Z",
			stroke: "#D9D9D9",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.8279 12.1905L14.8279 7.37433C14.8279 7.22987 14.5989 7.14921 14.4426 7.23867L10.2512 9.64676C10.1312 9.71569 10.1312 9.84842 10.2512 9.91808L14.4426 12.3262C14.5989 12.4156 14.8279 12.335 14.8279 12.1905Z",
			fill: "#434343"
		})
	]
});
const ForwardRef = forwardRef(SvgLeftKeyboardHints);
export { ForwardRef as ReactComponent };
